import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserLocalStorageService } from './services/user.local.storage.service';
import { authProvider } from './services/angular2-jwt.config';
import { HttpLogSubscriberService } from '../shared/log/http-log-subscriber.service';
import { ConsoleLogSubscriberService } from '../shared/log/console-log-subscriber.service';
import { LogService } from '../shared/log/log.service';
import { AuthorizeDirective } from './directive/authorization-directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    AuthorizeDirective
  ],
  providers: [
    LogService,
    ConsoleLogSubscriberService,
    HttpLogSubscriberService,
    UserLocalStorageService,
    authProvider
  ],
  exports: [
    AuthorizeDirective
  ]
})
export class PermissionModule {
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/permission/permission.module.ts